import { Location } from '@angular/common';
import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BookmarksModalService } from 'src/app/components/bookmarks/bookmarks-modal.service';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { LANG_SET } from 'src/app/helpers';
import { NavItem, NavItemChildren } from 'src/app/interfaces/nav-item';
import { SearchResult } from 'src/app/interfaces/search-result';
import { CoreStorageEnum } from 'src/app/models/core-storage.enum';
import { environment } from 'src/environments/environment';
import { ApplicationService } from 'src/app/services/application.service';
import { AuthService } from 'src/app/services/auth.service';
import { BookmarkService } from 'src/app/components/bookmarks/bookmark.service';
import { Language } from 'src/app/services/languages.service';
import { SearchService } from 'src/app/services/search.service';
import { SidebarService } from 'src/app/services/sidebar.service';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActionCommandService } from 'src/app/services/action-command.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent extends UnsubscriberComponent implements OnInit {
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  menus: NavItem[];
  applications: NavItemChildren[];

  searchForm: UntypedFormGroup;
  public newComandsCount: number = 0;
  isSidebarOpen$: Observable<boolean> = this.sidebarService.isSidebarOpen$;
  isBookmarksOpen$: Observable<boolean> = this.bookmarksModalService.isOpen$;
  isLightTheme$: Observable<boolean> = this.themeService.lightTheme$;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private authService: AuthService,
    private fb: UntypedFormBuilder,
    private searchService: SearchService,
    private ApplicationService: ApplicationService,
    @Inject(LANG_SET) public langSet: Language[],
    private sidebarService: SidebarService,
    private bookmarksModalService: BookmarksModalService,
    private actionCommandService: ActionCommandService,
    private themeService: ThemeService,
  ) {
    super();
    this.location = location;
  }

  ngOnInit() {
    this.subscriptions.add(
      this.actionCommandService.newEvents$.subscribe(count => this.newComandsCount = count)
    );
    this.searchForm = this.fb.group({
      search: [''],
    });
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      const $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });

    //  this.navOptions = this.ApplicationService.navItems$;

    this.subscriptions.add(
      this.ApplicationService.getNavItems().subscribe(
        (items) => (this.menus = items) // this.ApplicationService.updateNavItems(items)
      )
    );

    this.subscriptions.add(
      this.ApplicationService.getApplicationItems().subscribe(
        (items) => (this.applications = items) // this.ApplicationService.updateNavItems(items)
      )
    );
  }

  searchSubmit(): void {
    NProgress.start();
    this.subscriptions.add(
      this.searchService.search(this.searchForm.getRawValue().search).subscribe(
        (response) => {
          NProgress.done();
          const query = this.searchForm.get('search').value;
          this.searchService.updateHistory(query);
          this.searchService.setSearchData(response);
          //  response.length !== 1 ?
          this.router.navigate(['/search/results'], {
            queryParams: { query: query },
            state: { reason: 'submit' },
          }); // : this.handleSingleResult(response[0]);
        },
        (error) => {
          NProgress.done();
        }
      )
    );
  }

  public handleSingleResult(result: SearchResult): void {
    this.searchService.updateInstance(result.id);
    this.router.navigate([
      '/' + result.route + '/' + result.page + '/' + result.id,
    ]);
  }

  public logout(event) {
    event.preventDefault();
    this.subscriptions.add(
      this.authService.logout().subscribe(() => {
        this.router.navigate(['login']);
      })
    );
  }
  public changeApplication(applicationId) {
    localStorage.setItem(CoreStorageEnum.clientId, applicationId);
    this.subscriptions.add(
      this.ApplicationService.changeApplication(applicationId).subscribe(() => {
        location.href = '/';
      })
    );
  }

  public getClassItem(clientId:string) {
    //console.log(clientId);
    if (clientId.endsWith('1')) return 'prod-env';
    return 'test-env';
  }

  public getNavClass() {
    var clientId = localStorage.getItem(CoreStorageEnum.clientId);
    if (!clientId) return '';
    if (clientId.endsWith('8')) return 'red-border-env';
    return '';
  }

  public getClient() {
    var clientId = localStorage.getItem(CoreStorageEnum.clientId);
    if (!clientId) return '';
    if (clientId.endsWith('9')) return 'test environment';
    if (clientId.endsWith('8')) return 'uat environment';
    if (clientId.endsWith('4')) return 'stage environment';
    if (clientId.endsWith('1')) return '';
  }
  
  public getApplicationId() {
    return (localStorage.getItem(CoreStorageEnum.clientId) || environment.clientId).substring(0, 4);
  }

  public getUser() {
    return localStorage.getItem(CoreStorageEnum.username);
  }

  public toggleSidebar() {
    this.sidebarService.toggle();
  }

  public toggleBookmarks() {
    this.bookmarksModalService.toggle();
  }

  public toggleTheme(event: Event): void {
    event.preventDefault();
    this.themeService.toggle();
  }
}
